import React, { useState } from 'react';
import '../css/ForgotPassword.css';
import { useUser } from '../hooks/useUser';

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const { user } = useUser();

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        if (!email) {
            setMessage('Please enter your email address');
            setMessageType('error');
            return;
        }

        setLoading(true);
        setMessage('');

        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/forgot-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email }),
                credentials: 'include'
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(data.message);
                setMessageType('signup-success');
                setEmail('');
            } else {
                setMessage(data.message);
                setMessageType('error');
            }
        } catch (error) {
            setMessage('An error occurred while processing your request');
            setMessageType('error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="forgot-password-container">
            <div className="forgot-password-content">
                <div className="forgot-password-card">
                    <h2>{`${user ? "Reset Password" : "Forgot Password"}`}</h2>

                    <form onSubmit={handleForgotPassword}>
                        <div className="form-group">
                            <label htmlFor="email" className='login-label'>Email Address:</label>
                            <input
                                type="email"
                                id="email"
                                placeholder="Enter your email address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="input-field"
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            className="default-button submit-button"
                            disabled={loading}
                        >
                            {loading ? <div className='loader-small' /> : 'Send Reset Link'}
                        </button>
                    </form>

                    {message && (
                        <div className={`${messageType}`}>
                            {message}
                        </div>
                    )}
                    {!user ? (
                        <a href="/login" className='link switch'>
                            Back to Login
                        </a>
                    ) : (
                        <a href={`/profile/${user?.userNumber}`} className='link switch'>
                            Back to Profile
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
